import { useSelector } from 'react-redux';

const dayNum = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

export const useClosedDays = uuid => {
  const { restaurantsWithoutSelect, restaurantUuid } = useSelector(state => state.login);
  const restaurant = restaurantsWithoutSelect.find(({ value }) => value === (uuid || restaurantUuid));
  return restaurant
    ? [0, 1, 2, 3, 4, 5, 6].filter(n => !restaurant.workingHours.map(d => dayNum[d.dayOfWeek]).includes(n))
    : [];
};
